export default {
  SECTION: {
    MENU: 'menu',
    BANNER: 'banner',
    WHO_WE_ARE: 'whoWeAre',
    WHAT_WE_OFFER: 'whatWeOffer',
    WHO_WE_SERVE: 'whoWeServe',
    FOOTER: 'footer'
  }
}


// WEBPACK FOOTER //
// ./src/pages/home/consts.js